module.exports = __webpack_public_path__ + "img/67_1.16f64abc.png";